/**
 * BLOCK: Products Block.
 *
 * Registering a basic block with Gutenberg.
 * Simple block, renders and saves the same content without any interactivity.
 */

/**
 * External dependencies
 */
import { ButtonIcon } from '~cartzillagb/icons'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'
import { disabledBlocks, i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'

export const schema = {
	type: {
		type: 'string',
		default: 'default',
	},
	limit: {
		type: 'number',
		default: 3,
	},
	orderby: {
		type: 'string',
		default: 'title',
	},
	order: {
		type: 'string',
		default: 'ASC',
	},
	onSale: {
		type: 'boolean',
		default: false,
	},
	bestSelling: {
		type: 'boolean',
		default: false,
	},
	topRated: {
		type: 'boolean',
		default: false,
	},
	products: {
		type: 'array',
		default: [],
	},
	visibility: {
		type: 'string',
		default: 'visible',
	},
	exclude: {
		type: 'array',
		default: [],
	},
}

export const name = 'czgb/products-list'

export const settings = {
	title: __( 'Products List Block', i18n ),
	description: __( 'Add products list block.', i18n ),
	icon: ButtonIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'Products', i18n ),
		__( 'cartzillaGB', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,
}
